/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Caret-Down': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M12.1992 16.1807L17.1021 8.93729C17.2084 8.78165 17.0947 8.57129 16.9032 8.57129L7.09739 8.57129C6.90587 8.57129 6.79219 8.78165 6.89722 8.93729L11.8013 16.1807C11.8952 16.3205 12.1041 16.3205 12.1992 16.1807Z" />'
  }
})
